var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex flex-wrap align-items-center justify-content-center"
    },
    [
      !_vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-wrap align-items-center justify-content-center"
            },
            _vm._l(_vm.menus, function(menu, index) {
              return _c(
                "div",
                { key: index, staticClass: "d-flex align-items-center my-2" },
                [
                  menu.rota
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mx-2",
                          staticStyle: { width: "190px" },
                          attrs: { variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.openRoute(menu.rota)
                            }
                          }
                        },
                        [
                          _c("i", { class: "fas " + menu.icon + " mx-2" }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.limitarString(menu.label, 13)) +
                              "\n            "
                          )
                        ]
                      )
                    : _c(
                        "b-dropdown",
                        {
                          staticClass: "mx-2 align-items-center",
                          staticStyle: { width: "190px" },
                          attrs: { variant: "primary", id: "dropdown-1" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function() {
                                  return [
                                    _c("i", {
                                      class: "fas " + menu.icon + " mx-2"
                                    }),
                                    _vm._v(
                                      _vm._s(
                                        _vm.limitarString(menu.label, 13)
                                      ) + "\n                "
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm._l(menu.submenus, function(submenu, index_sub) {
                            return _c(
                              "b-dropdown-item",
                              {
                                key: index_sub,
                                attrs: { variant: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.openRoute(submenu.rota)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(submenu.label) +
                                    "\n                "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                ],
                1
              )
            }),
            0
          )
        : _c(
            "div",
            {
              staticClass:
                "skeletons d-flex flex-wrap align-items-center justify-content-center"
            },
            _vm._l(5, function(n) {
              return _c("div", {
                key: n,
                staticClass: "skeleton-item mx-2 my-2"
              })
            }),
            0
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-191e9e69", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-191e9e69","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_horizontal_navbar/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-191e9e69","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_horizontal_navbar/Main.vue
// module chunks = 2